import { EuiButtonEmpty, EuiFlexItem, EuiIcon, EuiPopover } from '@elastic/eui';
import { useDisclosure } from 'hooks/useDisclosure';
import * as S from './ListingCounter.style';
import { useIntl } from 'react-intl';

import { OrderByField, OrderByInput, OrderBySortDirection } from '../../generated/graphql';

const ACTIVE_SORTING_FIELDS = [
  OrderByField.VehicleKm,
  OrderByField.PriceInformation,
  OrderByField.PublishDateIso8601,
  OrderByField.VehicleRegistrationDateIso8601,
  OrderByField.VehicleKm,
];
export const SortResults: (p: { onChange: (filter: OrderByInput) => void; sorting: OrderByInput }) => JSX.Element = ({
  onChange,
  sorting,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { formatMessage } = useIntl();

  const sortingOptions: Array<{
    label: string;
    value: OrderByInput;
  }> = Object.values(OrderByField)
    .filter((x: OrderByField) => ACTIVE_SORTING_FIELDS.includes(x))
    .map((field) =>
      Object.values(OrderBySortDirection).map((sort) => ({
        value: {
          field,
          sortDirection: sort,
        },
        label: formatMessage({ id: `${field}.${sort}` }),
      }))
    )
    .flat();

  return (
    <>
      <p>{formatMessage({ id: 'orderBy' }) + ':'}</p>
      <EuiPopover
        id="popover2"
        panelPaddingSize="m"
        button={
          <S.ListingCounterSort onClick={onOpen} onBlur={onClose}>
            {sorting?.field || sorting?.sortDirection
              ? formatMessage({ id: `${sorting.field}.${sorting.sortDirection}` })
              : null}
            <EuiIcon size="s" type={sorting?.sortDirection === 'asc' ? 'sortUp' : 'sortDown'} />
          </S.ListingCounterSort>
        }
        isOpen={isOpen}
        closePopover={onClose}
        ownFocus
        anchorPosition="downLeft"
        style={{ cursor: 'pointer', marginLeft: '10px' }}
      >
        <EuiFlexItem grow={false} style={{ alignItems: 'start' }}>
          {sortingOptions.map(({ value, label }) => (
            <EuiButtonEmpty
              color="primary"
              key={value.field}
              onClick={(): void => {
                onChange(value);
                onClose();
              }}
            >
              {label}
            </EuiButtonEmpty>
          ))}
        </EuiFlexItem>
      </EuiPopover>
    </>
  );
};
